var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexChart',{attrs:{"width":"110px","height":"100px","type":"area","options":_vm.options,"series":_vm.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }